import type { ReactNode } from 'react';

export const symbol_scatter_plot: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M587-163q-43-43-43-105t43-105q43-43 105-43t105 43q43 43 43 105t-43 105q-43 43-105 43t-105-43Zm168-42q25-25 25-63t-25-63q-25-25-63-25t-63 25q-25 25-25 63t25 63q25 25 63 25t63-25Zm-592-88q-43-43-43-105t43-105q43-43 105-43t105 43q43 43 43 105t-43 105q-43 43-105 43t-105-43Zm167.5-42.5Q356-361 356-398t-25.5-62.5Q305-486 268-486t-62.5 25.5Q180-435 180-398t25.5 62.5Q231-310 268-310t62.5-25.5ZM332-627q-43-43-43-105t43-105q43-43 105-43t105 43q43 43 43 105t-43 105q-43 43-105 43t-105-43Zm168-42q25-25 25-63t-25-63q-25-25-63-25t-63 25q-25 25-25 63t25 63q25 25 63 25t63-25Zm192 401ZM268-398Zm169-334Z"
		/>
	</svg>
);
